import { YStack, YStackProps } from 'tamagui'

interface MobileFriendlyStackProps extends YStackProps {
    breakpoint?: 'sm' | 'md' | 'lg'
}

export const MobileFriendlyStack = ({ children, breakpoint, ...props }: MobileFriendlyStackProps) => {
    return (
        <YStack
            gap="$3"
            $sm={{ flexDirection: 'row', alignItems: 'flex-end', gap: '$4' }}
            {...props}
        >
            {children}
        </YStack>
    )
}
